<template>
<div>
  <el-form-item label="题干">
    <PinyinGridInput :text.sync="subject.text" :pinyin.sync="subject.pinyin"></PinyinGridInput>
  </el-form-item>
  <el-form-item label="提示">
    <ArrayItem :items="tips">
      <template #default="{item}">
        <PinyinGridInput :text.sync="item.text" :pinyin.sync="item.pinyin"></PinyinGridInput>
      </template>
    </ArrayItem>
  </el-form-item>
  <el-form-item label="提问">
    <ArrayItem :items="questions">
      <template #default="{item}">
        <PinyinGridInput :text.sync="item.text" :pinyin.sync="item.pinyin"></PinyinGridInput>
      </template>
    </ArrayItem>
  </el-form-item>
</div>
</template>

<script>
// import PinyinPreview from "@/components/PinyinPreview"
// import PinyinInput from "@/components/PinyinInput"
import PinyinGridInput from "@/components/PinyinGridInput"
import ArrayItem from "@/components/ArrayItem.vue";

export default {
  name: 'HdwtForm',
  components: {
    ArrayItem,
    // PinyinPreview,
    // PinyinInput,
    PinyinGridInput,
  },
  props: {
    config: Object,
    model: Object,
  },
  data() {
    return {
      subject: {},
      tips: [],
      questions: [],
    }
  },
  watch: {
    model(val) {
      this.normalizedModel(val);
    }
  },
  created() {
    this.normalizedModel(this.model);
  },
  methods: {
    normalizedModel(val) {
      const {subject, tips, questions} = val || {};
      this.subject = subject || {};
      this.tips = tips && tips.length > 0 ? tips : [{}];
      this.questions = questions && questions.length > 0 ? questions : [{}];
    },
    getFormData() {
      const {model, subject, tips, questions} = this;
      return {...model, subject, tips: tips.filter(n => n.text), questions: questions.filter(n => n.text)};
    }
  }
}
</script>